var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"top-nav"}},[_c('div',{staticClass:"top_nav_wraper"},[_c('div',{staticClass:"topnav"},[_vm._t("default")],2),_vm._t("topnavMenu")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }